/* Olivia Mendoza: colores con la foto de la variante (ficha y vista rápida), sin metacampos.
   Cada ficha deja un <script type="application/json" data-om-swatches> con { color: url }; este script convierte
   los botones de esa opción en miniaturas. Se carga una vez en el layout y vigila el DOM, así también funciona en
   la vista rápida, que Horizon pinta después con HTML de la ficha (allí los <script> en línea no se ejecutan). */
(function () {
  var COLOR = /colou?r/i;
  var urlVistaRapida = '';      // ficha abierta en la vista rápida
  var mapasPorUrl = {};         // url -> { opcion, mapa } (sacado de /products/<handle>.js)

  function pinta(raiz, opcion, mapa) {
    raiz.querySelectorAll('input[data-option-name]').forEach(function (inp) {
      if (inp.getAttribute('data-option-name') !== opcion) return;
      var label = inp.closest('label') || (inp.id && raiz.querySelector('label[for="' + inp.id + '"]'));
      var url = mapa[inp.value];
      if (!label || !url || label.querySelector('.om-sw__img')) return;
      label.classList.add('om-sw');
      var fs = label.closest('fieldset'); if (fs) fs.classList.add('om-sw-row');
      var img = document.createElement('img');
      img.className = 'om-sw__img'; img.src = url; img.alt = ''; img.loading = 'lazy';
      label.insertBefore(img, label.firstChild);
      label.title = inp.value;
    });
  }

  /* la vista rápida en móvil quita el bloque con los datos: se piden a Shopify con la url de la ficha */
  function limpia(url) { return (url || '').split('?')[0].split('#')[0]; }
  function mapaDeVistaRapida(dialogo) {
    if (!urlVistaRapida) return;
    var u = limpia(urlVistaRapida);
    var hay = mapasPorUrl[u];
    if (hay && hay.opcion) {
      pinta(dialogo, hay.opcion, hay.mapa);
      dialogo.querySelectorAll('fieldset.om-sw-wait').forEach(function (f) { f.classList.remove('om-sw-wait'); });
      return;
    }
    /* mientras llegan las fotos, el color no se enseña en texto (como mucho 1,5 s) */
    dialogo.querySelectorAll('input[data-option-name]').forEach(function (inp) {
      var f = inp.closest('fieldset');
      if (f && COLOR.test(inp.getAttribute('data-option-name')) && !f.classList.contains('om-sw-row')) f.classList.add('om-sw-wait');
    });
    setTimeout(function () { dialogo.querySelectorAll('fieldset.om-sw-wait').forEach(function (f) { f.classList.remove('om-sw-wait'); }); }, 1500);
    pide(u);
  }
  /* se pide antes de abrir (al tocar o pasar por encima del botón), así las fotos ya están al pintarse */
  function pide(u) {
    if (!u || mapasPorUrl[u]) return;
    mapasPorUrl[u] = {};
    fetch(u + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var i = (p.options || []).findIndex(function (o) { return COLOR.test(o.name || o); });
      if (i < 0) return;
      var mapa = {};
      (p.variants || []).forEach(function (v) {
        var val = v['option' + (i + 1)];
        var src = v.featured_image && v.featured_image.src;
        if (val && src && !mapa[val]) mapa[val] = src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=160';
      });
      mapasPorUrl[u] = { opcion: p.options[i].name || p.options[i], mapa: mapa };
      aplica();
    }).catch(function () {});
  }

  function aplica() {
    document.querySelectorAll('script[data-om-swatches]').forEach(function (el) {
      var mapa; try { mapa = JSON.parse(el.textContent); } catch (e) { return; }
      var raiz = el.closest('dialog, .quick-add-modal, product-information, .product-information') || document;
      pinta(raiz, el.getAttribute('data-option'), mapa);
    });
    document.querySelectorAll('dialog[open], .quick-add-modal').forEach(function (d) {
      if (d.querySelector('input[data-option-name]') && !d.querySelector('script[data-om-swatches]')) mapaDeVistaRapida(d);
    });
  }
  /* se aplica en el mismo instante en que Horizon mete el HTML (antes de pintar), sin salto de texto a foto */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aplica); else aplica();
  new MutationObserver(aplica).observe(document.documentElement, { childList: true, subtree: true });
  function adelanta(e) {
    var b = e.target.closest && e.target.closest('[data-om-qv][data-url]');
    if (b) pide(limpia(b.getAttribute('data-url')));
  }
  document.addEventListener('pointerdown', adelanta, true);
  document.addEventListener('touchstart', adelanta, { capture: true, passive: true });
  /* "Vista rápida" propio: pulsa el botón de quick add de Horizon de esa tarjeta */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-om-qv]');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('.om-card, .product-card, product-card');
    var url = b.getAttribute('data-url') || '';
    urlVistaRapida = url;
    var comp = card && card.querySelector('quick-add-component');
    var q = card && card.querySelector('.quick-add__button');
    /* fuera de un <product-card> de Horizon (tarjetas del inicio) el quick add no sabe qué ficha abrir: se le dice */
    if (comp && url && !comp.closest('product-card')) {
      try { Object.defineProperty(comp, 'productPageUrl', { configurable: true, get: function () { return new URL(url, location.origin).href; } }); } catch (err) {}
    }
    if (q) q.click(); else if (url) window.location = url;
  });
  /* "Guía de tallas" junto a la opción Talla, como en el theme anterior: abre la ventana del kit (dialog.acx-sizemodal) */
  var TALLA = /^(talla|tallas|size|tamaño)$/i;
  function enlaceTallas() {
    document.querySelectorAll('dialog.acx-sizemodal').forEach(function (dlg) {
      var raiz = dlg.closest('product-information, .product-information, main') || document;
      var key = dlg.id.replace('AcxSizeChart-', '');
      raiz.querySelectorAll('fieldset').forEach(function (fs) {
        var inp = fs.querySelector('input[data-option-name]');
        if (!inp || !TALLA.test((inp.getAttribute('data-option-name') || '').trim()) || fs.querySelector('.acx-sizelink')) return;
        var a = document.createElement('a');
        a.href = '#'; a.className = 'acx-sizelink om-sizelink'; a.setAttribute('data-acx-sizeguide', key);
        a.textContent = (dlg.getAttribute('aria-label') || 'Guía de tallas');
        var leyenda = fs.querySelector('legend');
        if (leyenda) leyenda.appendChild(a); else fs.insertBefore(a, fs.firstChild);
      });
    });
  }
  /* abrir la guía en páginas sin el script del kit (colecciones, inicio: la vista rápida mete su HTML sin ejecutar los
     <script>). En la ficha ya lo hace product-extras, que marca window.__acxSizeChart. */
  function abreTallas() {
    if (window.__acxSizeChart) return;
    window.__acxSizeChart = true;
    function cierra(dlg) { dlg.close(); document.documentElement.classList.remove('acx-noscroll'); }
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-acx-sizeguide]');
      if (link) {
        e.preventDefault(); e.stopPropagation();
        var key = link.getAttribute('data-acx-sizeguide');
        var cerca = link.closest('dialog, .quick-add-modal, product-information') || document;
        var dlg = cerca.querySelector('#AcxSizeChart-' + key) || document.getElementById('AcxSizeChart-' + key);
        if (!dlg || typeof dlg.showModal !== 'function') return;
        if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
        if (!dlg.open) dlg.showModal();
        return;
      }
      var abierto = e.target.closest && e.target.closest('dialog.acx-sizemodal[open]');
      if (abierto && (e.target === abierto || e.target.closest('[data-acx-close]'))) { e.preventDefault(); e.stopPropagation(); cierra(abierto); }
    }, true);
    document.addEventListener('keydown', function (e) {
      var abierto = e.key === 'Escape' && document.querySelector('dialog.acx-sizemodal[open]');
      if (abierto) { e.preventDefault(); e.stopPropagation(); cierra(abierto); }
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abreTallas); else abreTallas();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enlaceTallas); else enlaceTallas();
  new MutationObserver(enlaceTallas).observe(document.documentElement, { childList: true, subtree: true });

  /* estrellas bajo el título: bajan hasta el widget de reseñas de Loox (o Judge.me) con desplazamiento suave */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-om-resenas]');
    if (!a) return;
    var destino = document.getElementById('looxReviews') || document.querySelector('.loox-widget:not(.loox-rating), [id^="looxReviews"], #judgeme_product_reviews, .jdgm-review-widget');
    if (!destino) return;
    e.preventDefault();
    var y = destino.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
  /* precargar la ficha al pasar por encima, para que la vista rápida abra antes */
  document.addEventListener('pointerover', function (e) {
    var b = e.target.closest && e.target.closest('[data-om-qv][data-url]');
    if (!b || b.__omPre) return; b.__omPre = true;
    var l = document.createElement('link'); l.rel = 'prefetch'; l.href = b.getAttribute('data-url'); document.head.appendChild(l);
    pide(limpia(b.getAttribute('data-url')));
  });
})();
